<script>
    import {Loader} from '@googlemaps/js-api-loader';

    export default {
        name: "RetailerMaps",

        emits: ['change', 'change-retailer'],

        props : [
            'retailers',
            'filteredRetailers',
            'height',
            'currentRetailer'
        ],

        data() {
                return {
                map : null,
                mapOptions : null,
                google : null,
                norwayCenter : {
                    lat: 61.92122020128065,
                    lng: 9.705509948213278
                },
                markers: [],
                allRetailers: [],
                mapId: null,
            }
        },

        watch: {
            currentRetailer() {
                this.panToMarker();
            },

            filteredRetailers() {
                this.filterMarkers();
            }
        },

        created()  {
            this.allRetailers = this.retailers || [];
            this.initMap();
        },

        methods: {
            initMap() {
                this.mapId =  'js_retailers-map-'+(Math.random() + 1).toString(36).substring(7);
                const loader = new Loader({
                // apiKey: "", // TODO set api key
                apiKey: "AIzaSyCJV3WaUeG2c7BikmoiJ4CF39PyPuZ1br8",
                version: "weekly",
                libraries: ["places", 'geometry']
            });

                loader.loadCallback(e => {
                if (e) {

            } else {
                const mapContainer = document.getElementById(this.mapId);
                if (mapContainer) {
                    this.google = google;
                    this.map = new google.maps.Map(mapContainer, this.mapOptions);
                    this.createMarkers();
                    this.filterMarkers();
                    this.panToMarker();
                }
            }
            });
        },

        convertPositions(retailer)  {
            const lng = parseFloat(retailer.position.lng);
            const lat = parseFloat(retailer.position.lat);

            return {lng: lng, lat: lat}
        },

        createMarkers()  {
            this.allRetailers.forEach(retailer => {
                this.markers[retailer.id] = new this.google.maps.Marker({
                    position: this.convertPositions(retailer),
                });
            });
        },

        setMarkers(){
                this.markers.forEach((marker, retailerId) => {
                    this.google.maps.event.addListener(marker, 'click', () => {
                    this.$emit('change-retailer', retailerId)
                })
                marker.setMap(this.map);
            });
        },

        filterMarkers(){
            this.setMarkers();
            let retailersToExclude = [];

            if (this.filteredRetailers){
                retailersToExclude = this.allRetailers.filter(ret => !this.filteredRetailers.includes(ret));
            }

            retailersToExclude.forEach(ret => {
                this.markers[ret.id].setMap(null);
            });
        },

        panToMarker(){
            let panTo = this.currentRetailer && this.currentRetailer.position ? this.convertPositions(this.currentRetailer) : this.norwayCenter;
            let zoom = this.currentRetailer && this.currentRetailer.position ? 13 : 4;

            this.map.panTo(panTo);
            this.map.setZoom(zoom);
        }
    },

    }
</script>


<template>
<div class="retailers-map retailers-map-component" :id="mapId" ></div>
</template>